"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settlementRewardSelectState = exports.settlementFondeeDayState = exports.settlementDetailsDataState = exports.settlementManageTabValueState = exports.settlementTotalAmountState = void 0;
const recoil_1 = require("recoil");
exports.settlementTotalAmountState = (0, recoil_1.atom)({
    key: 'settlementTotalAmountState',
    default: { total_withdrawable_amount: 0, total_reward_amount: 0 },
});
exports.settlementManageTabValueState = (0, recoil_1.atom)({
    key: 'settlementManageTabValueState',
    default: 'settlementDetails',
});
exports.settlementDetailsDataState = (0, recoil_1.atom)({
    key: 'settlementDetailsDataState',
    default: {
        id: 0,
        fee_free: false,
        entered_waybill_count: 0,
        room_status_cd: 'ROOM_STATUS_00',
        room_type_cd: 'ROOM_TYPE_00',
        settlement_list: [],
    },
});
exports.settlementFondeeDayState = (0, recoil_1.atom)({
    key: 'settlementFondeeDayState',
    default: {
        isFondeeDayLoaded: false,
        fondeeDayArr: [],
    },
});
exports.settlementRewardSelectState = (0, recoil_1.atom)({
    key: 'settlementRewardSelectState',
    default: 'keep',
});
